<template>
  <div class="detail-body-pre">
    <div class="detail-body__buy" v-if="isPayed && myGidLast > 0">
      <p>11月10日22点前支付定金；11月11日当天24点，前如期支付尾款，可享受双11特惠价</p>
      <van-button v-if="isPayed" disabled block size="big" type="danger" text="购买成功" />
    </div>
    <div class="detail-body__buy" v-else-if="isPayed">
      <p>定金支付成功，请于11月11日当天24点前完成尾款支付，逾期无效！</p>
      <goods-button-buy v-if="isPayed" block size="big" :goods-id="goodsId" text="支付尾款" />
    </div>
    <div class="detail-body__buy" v-else>
      <p>11月10日22点前支付定金；11月11日当天24点前，如期支付尾款，可享受双11特惠价</p>
      <goods-button-buy :goods-id="goodsId" size="big" block />
    </div>
  </div>
</template>

<script>
  import {
    Row, Col
  } from 'vant';
  import {
    mapGetters
  } from 'vuex';

  export default {
    components: {
      'van-row': Row,
      'van-col': Col
    },
    data() {
      return {

      }
    },
    props: ['goodsId'],
    computed: {
      ...mapGetters(['waitLastId', 'goodsInfo', 'leftSecsPre',
        'leftSecsBegin',
        'leftSecsEnd',
        'sec2txt',
        'myGidLast'
      ]),
      goods() {
        return this.goodsInfo(this.goodsId)
      },
      isPayed() {
        return this.$store.getters.isPayed(this.goodsId)
      },
      isPre() {
        return this.$store.getters.isPre(this.goodsId)
      },
      isLast() {
        return this.$store.getters.isLast(this.goodsId)
      }
    }
  }
</script>
